<script>
    import {onMount} from "svelte";
    import wrappedFetch from "../wrappedFetch.js";
    import Spinner from "./components/spinner.svelte";
    import Card from "./components/card.svelte";
    import Modal from "./components/modal.svelte";
    import DataTable from "../components/data-table.svelte";

    let classes=[];
    let groups=[];
    let pupils=[];
    let isPageLoading;
    let showPupils=false;

    onMount(async()=>{
        isPageLoading=true;
        let resp = await wrappedFetch("/api/reports/GetClassAndGroupData?data=input", {method: "post"}); 
        let result  = await resp.json();
        classes = result.classes;
        groups = result.groups;
        isPageLoading=false;
    })

    const getPupilInClass=async (classId)=>{
        pupils=[];
        showPupils = true;
        let resp = await wrappedFetch(`/api/reports/getpupilinclass?classid=${classId}`, {method: "post"}); 
        pupils = await resp.json();  
    }

    const getPupilInGroup=async (classId)=>{
        pupils=[];
        let resp = await wrappedFetch(`/api/reports/getpupilingroup?groupid=${classId}`, {method: "post"}); 
        pupils = await resp.json();   
        showPupils = true;
    }

    document.addEventListener('click', function (event) {
        if (!event.target.matches('.ClassPupils')) return;
            if (jQuery('div.dtr-bs-modal').length > 0){
                jQuery('.dtr-bs-modal').modal('hide');
            }
            getPupilInClass(event.target.getAttribute('data'));
    }, false);

    function PupilClass(event){
        // if (event.detail.text == "TableUpdated"){
        //     jQuery(".table").on('click','.ClassPupils', function () { 
        //         var dataString = jQuery(this).attr('data');
        //         if (jQuery('div.dtr-bs-modal').length > 0){
        //             jQuery('.dtr-bs-modal').modal('hide');
        //         }
        //         getPupilInClass(dataString);
        //     });
        // }
    }
    
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.ClassGroup')) return;
            if (jQuery('div.dtr-bs-modal').length > 0){
                jQuery('.dtr-bs-modal').modal('hide');
            }
            getPupilInGroup(event.target.getAttribute('data'));
    }, false);
    
     function PupilGroup(event){
    //     if (event.detail.text == "TableUpdated"){
    //         jQuery(".table").on('click','.ClassGroup', function () { 
    //             var dataString = jQuery(this).attr('data');
    //             if (jQuery('div.dtr-bs-modal').length > 0){
    //                 jQuery('.dtr-bs-modal').modal('hide');
    //             }
    //             getPupilInGroup(dataString);
    //         });
    //     }
     }
</script>

<svelte:head>
    <title>Classes | Wavenet Nimbus </title>
</svelte:head>

<h1>Classes</h1>
<p>These are the classes that are being imported into Nimbus and they are displayed here for reference.</p>

{#if showPupils}
    <Modal bind:showModal={showPupils} showFooter={false} sizeClass={"modal-md"}>
        <div slot="header">
            <h4>Pupils</h4>
        </div>
        <div slot="content">
            <DataTable DataLength={pupils.length}>
                <thead><tr><th>Pupil Name</th></tr></thead>
                <tbody>
                    {#each pupils as pupil}<tr><td>{pupil}</td></tr>{/each}
                </tbody>
            </DataTable>
        </div>
    </Modal>
{/if}

{#if isPageLoading}
   <Spinner/>
{:else}
    <ul class="nav nav-tabs"> 
        <li class="nav-item">
            <a class="active nav-link" data-toggle="tab" href="#tab1">Subject Classes</a>
        </li>  
        <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#tab2">Registration Classes</a>
        </li>   
    </ul>
    <br />
    <div class="tab-content">
        <div class="tab-pane active" id="tab1">
            <Card cardTable={true}>  
                <div slot = "body">
                    <DataTable DataLength={classes.length} message = "There are currently no classes of this type being imported." on:message={PupilClass}>
                        <thead>
                            <tr>                    
                                <th>Class</th>                                 
                                <th>Subject</th>
                                <th>Supervisor</th>
                                <th>Pupils</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each classes as cl}
                            <tr>
                                <td>{cl.className || ""}</td>
                                <td>{cl.subject || ""}</td>                       
                                <td>{cl.supervisor || ""} </td>
                                <td>
                                    {#if cl.totalPupil > 0}<a class="ClassPupils" href="javascript:;" data={cl.classID} on:click={()=>{getPupilInClass(cl.classID)}}>{cl.totalPupil}</a>{:else}{cl.totalPupil}{/if}
                                </td>
                            </tr>
                            {/each}
                        </tbody>
                    </DataTable>
                </div>
            </Card>   
        </div>
        <div class="tab-pane" id="tab2">
            <Card cardTable={true}>  
                <div slot = "body">
                    <DataTable DataLength={groups.length} message="There are currently no classes of this type being imported." on:message={PupilGroup}>
                        <thead>
                            <tr>                    
                                <th>Class</th>   
                                <th>Supervisor</th>
                                <th>Pupils</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each groups as g}
                            <tr>
                                <td>{g.className || ""}</td>                                                    
                                <td>{g.supervisor || ""} </td>
                                <td>{#if g.totalPupil > 0}<a class="ClassGroup" href="javascript:;" data={g.classID}>{g.totalPupil}</a>{:else}{g.totalPupil}{/if}</td>
                            </tr>
                            {/each}
                        </tbody>
                    </DataTable>
                </div>
            </Card>   
        </div>
    </div>

      
{/if}